import attendanceReport from './ForgotToPunch'

export default attendanceReport;
